import React, { useEffect, useState, useRef,useMemo,useCallback } from "react";
import {
  Box, Flex, Text,
  useDisclosure,
  Heading,
  Spinner,
  Button,
  HStack,
} from "@chakra-ui/react";
import { ZoomImageModal } from "../../components/ZoomImageModal/ZoomImageModal";
import Select from "react-select";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import AgGridWrapper from "../../components/AgGrid/AgGridWrapper";

import apiClient from "Configuration/apiClient";
import API_CONFIG from "../../Configuration/apiConfig";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { getCurrentDate, getFirstDayOfMonth } from "../../Utils/dateUtils";
import { generatePresignedUrl } from "../../Utils/s3Utils";
import { useDateFilter } from "../../Hooks/useDateFilter";
import { SCREEN_KEYS } from "../../constants/screenKeys";

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#C72127",
    borderColor: "white",
    fontWeight: "bold",
    minHeight: "40px",
    borderRadius: "12px",
    boxShadow: state.isFocused ? '0 0 0 3px rgba(199, 33, 39, 0.3)' : 'none',
    cursor: 'pointer',
    "&:hover": {
      borderColor: "white",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "white",
    fontWeight: "bold",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#fff",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#2D3748",
    fontWeight: "600",
  }),
  multiValueRemove: (base) => ({
    ...base,
    "&:hover": {
      backgroundColor: "#e70b0b",
      color: "white",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "white",
    fontWeight: "bold",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#2C7A7B"
      : state.isFocused
        ? "#E6FFFA"
        : "white",
    color: state.isSelected ? "white" : "#2D3748",
  }),
}

export default function VisiCoolerImageReport() {
  const [filterStores, setFilterStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [storeName, setStoreName] = useState([]);
  const [error, setError] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [filteredCount, setFilteredCount] = useState(0);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [asm, setAsm] = useState([]);
  const [selectedAsm, setSelectedAsm] = useState([]);
  const [Rsm, setRsm] = useState([]);
  const [selectedRsm, setSelectedRsm] = useState([]);
  const [asmLoading, setAsmLoading] = useState(false);
  const [rsmLoading, setRsmLoading] = useState(false);
  

  const { fromDate, toDate, setFromDate, setToDate } = useDateFilter(
    SCREEN_KEYS.VISI_COOLER_IMAGE_REPORT ,
    { fromDate: getFirstDayOfMonth(), toDate: getCurrentDate() }
  );

  const fetchDebounceRef=useRef(null);
  const abortControllerRef=useRef(null);

 const handleFromDateChange = (value) => {
    setFromDate(value);
    if (value > toDate) setToDate(value);
  };

  const handleToDateChange = (value) => {
    if (value < fromDate) return;
    setToDate(value);
  };
  
  const fetchDropdownData = useCallback(async (searchType, setoptions, setLoading) => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.VISICOOLER.ASMDP}`,
        { params: { search: searchType } }
      );
      const data = response.data

      const formattedOptions = data.map((item) => ({
        value: item,
        label: item,
      }));
      setoptions(formattedOptions)
    } catch (err) {
      console.error(`Failde to fetch ${searchType}:`, err);
    } finally {
      setLoading(false);
    }
  },[]);

  useEffect(() => {
    Promise.all([
       fetchDropdownData("ASM", setAsm, setAsmLoading),
       fetchDropdownData("RSM", setRsm, setRsmLoading),
    ])
   
  },[]);
     

  useEffect(()=>{

    if (!fromDate || !toDate) return;

    if(fetchDebounceRef.current){
      clearTimeout(fetchDebounceRef.current)
    }
    fetchDebounceRef.current=setTimeout(async () => {
       if (abortControllerRef.current) abortControllerRef.current.abort();
       const controller = new AbortController();
       abortControllerRef.current = controller;

    setLoading(true);
    setStoreName([]);

    
      const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(v => parseInt(v, 10));
      const [toYear, toMonthNum, toDay] = toDate.split("-").map(v => parseInt(v, 10));
      const requestBody = {
        timePeriod: {
          from: {
            date: fromDay,
            month: fromMonthNum,
            year: fromYear,
          },
          to: {
            date: toDay,
            month: toMonthNum,
            year: toYear
          }
        },
        filters: {
          asmName: selectedAsm.map(asm => asm.value),
          rsmName: selectedRsm.map(rsm => rsm.value)
        }
      }

      try {
        const res = await apiClient.post(
          `${API_CONFIG.ENDPOINTS.VISICOOLER.STORE_WISE_IMAGES}`,
          requestBody,
          { signal: controller.signal }  
        );

        if (!res.data || !Array.isArray(res.data)) {
          setStoreName([]);
          setFilterStores([]);
          return;
        }

        const data = res.data.map((item) => ({
          storeName: item.storeResponse?.storeName || "",
          Ps: item.storeAdditionalDetails?.psName || "",
          distributor: item.storeAdditionalDetails?.distributor || "",
          so: item.storeAdditionalDetails?.salesOfficer || "",
          customerID: item.storeAdditionalDetails?.customer || "",
          imagePath: item.coolerImagePath || null,
        })).sort((a, b) => {
          const nameA = a.storeName.toLowerCase();
          const nameB = b.storeName.toLowerCase();

          const startsWithLetterA = /^[a-z]/i.test(nameA);
          const startsWithLetterB = /^[a-z]/i.test(nameB);

          if (startsWithLetterA && !startsWithLetterB) return -1;
          if (!startsWithLetterA && startsWithLetterB) return 1;

          return nameA.localeCompare(nameB);
        })

        setStoreName(data);
        setFilterStores(data);

      } catch (err) {
        console.error("Failed to fetch  store names:", err);
        setError("Failed to fetch store names. Please try again.");
        setStoreName([]);
        setFilterStores([]);
      } finally {
        if (!controller.signal.aborted)setLoading(false);
      }
    },300);

     return () => {
      if (fetchDebounceRef.current) clearTimeout(fetchDebounceRef.current);
    };
    
  }, [fromDate, toDate, selectedAsm, selectedRsm]);
 

  const handleViewDetails =useCallback(async(store) => {
    setSelectedStore(store);
    setImageUrl(null);
    onOpen();
    
    if (!store.imagePath){
      setImageLoading(false);
      return;
    }
    setImageLoading(true);
      try {
        const [year, month] = toDate.split("-").map(v => parseInt(v, 10));
        const presignedUrl = await generatePresignedUrl(store.imagePath, { month, year });  

        if (presignedUrl) {
          setImageUrl(presignedUrl);
        }
        else {
         console.error("presignedUrl came back null for:", store.imagePath);
       }
      } catch (error) {
        console.error('Failed to load image:', error);
      } finally {
        setImageLoading(false);
      }
    },[toDate,onOpen]);
  
    const onFilterChanged = useCallback((params) => {
      if (params?.api) setFilteredCount(params.api.getDisplayedRowCount());
    }, []);

    const onGridReady = (params) => {
      setGridApi(params.api);
      setFilteredCount(params.api.getDisplayedRowCount());
    };

  const totalPages = Math.ceil(filteredCount / pageSize);


    const handlePrevious =useCallback(() => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
        gridApi?.paginationGoToPreviousPage();
      }
    },[currentPage, gridApi]);

    const handleNext = useCallback(() => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
        gridApi?.paginationGoToNextPage();
      }
    },[currentPage, totalPages, gridApi]);
    

  const handleDownloadImages = useCallback(async () => {
    setDownloadLoading(true);
    try {
      const filterData = [];
      if (gridApi) gridApi.forEachNodeAfterFilter((node) => filterData.push(node.data));
      const dataToDownload = filterData.length > 0 ? filterData : filterStores;
      const storesWithImages = dataToDownload.filter((s) => s.imagePath);

      if (storesWithImages.length === 0) {
        alert("No images available to download!");
        return;
      }

      const zip = new JSZip();
      const [year, month] = toDate.split("-").map(Number);
      const BATCH_SIZE = 5; 

      for (let i = 0; i < storesWithImages.length; i += BATCH_SIZE) {
        const batch = storesWithImages.slice(i, i + BATCH_SIZE);
        await Promise.all(
          batch.map(async (store) => {
            try {
              const presignedUrl = await generatePresignedUrl(store.imagePath, { month, year });
              if (!presignedUrl) return;
              const response = await fetch(presignedUrl);
              if (!response.ok) return;
              const blob = await response.blob();
              const fileName = `${store.customerID || "0"}.jpg`;
              zip.file(fileName, blob);
            } catch (err) {
              console.error(`Error downloading image for ${store.customerID}:`, err);
            }
          })
        );
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `Visicooler_Images_${fromDate}_to_${toDate}.zip`);
    } catch (error) {
      console.error("Download process failed:", error);
      alert("Failed to download images. Please try again.");
    } finally {
      setDownloadLoading(false);
    }
  }, [gridApi, filterStores, toDate, fromDate]);



  // AG Grid Column Definitions
  const columnDefs = useMemo(()=>[
    {
      headerName: "Sales Officer",
      field: "so",
      minwidth: 130,
      flex: 1,
    },
    {
      headerName: "PS Name",
      field: "Ps",
      minwidth: 130,
      flex: 1,
    },
    {
      headerName: "Distributor Name",
      field: "distributor",
      minWidth: 130,
      flex: 1,
    },

    {
      headerName: "Store Name",
      field: "storeName",
      minWidth: 130,
      flex: 1,
    },
    {
      headerName: "Customer ID",
      field: "customerID",
      minWidth: 90,
      flex: 0.8,
    },

    {
      headerName: "Images",
      field: "imagePath",
      cellRenderer: (params) => {
        return params.value ? (
          <Flex align="center" h="100%">
            <Button
              size="sm"
              colorScheme="red"
              variant="outline"
              onClick={() => handleViewDetails(params.data)}
              leftIcon={<Box as="span">👁</Box>}
              fontSize={{ base: "xs", md: "md" }}
            >
              View
            </Button>
          </Flex>
        ) : (
          <Text color="gray.500" fontSize={{ base: "xs", sm: "sm", md: "md" }}>
            N/A
          </Text>
        );
      },
      minWidth: 120,
      flex: 0.8,
    },
  ],[handleViewDetails]);

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      pt={{ base: "7vh", sm: "8vh", md: "9vh", lg: "10vh" }}
      px={{ base: 3, sm: 4, md: 6, lg: 8 }}
      pb={{ base: 4, sm: 5, md: 6 }}
    >
      <Box mb={{ base: 4, sm: 5, md: 6 }}>
        <Flex
          direction={{ base: "column", sm: "row" }}
          justify="space-between"
          align={{ base: "flex-start", sm: "center" }}
          mb={{ base: 3, sm: 4, md: 4 }}
          gap={{ base: 3, sm: 0 }}
        >
          <Heading
            as="h1"
            fontSize={{ base: "20px", sm: "25px", md: "30px", lg: "35px" }}
            fontWeight="bold"
            color="gray.800"
            mb={{ base: 3, sm: 4, md: 4 }}
          >
            Store-wise Visicooler Images
          </Heading>

          <Flex
            gap={{ base: 2, sm: 3, md: 3 }}
            direction={{ base: "column", sm: "row" }}
            w={{ base: "100%", sm: "auto" }}
            align={{ base: "stretch", sm: "flex-end" }}
            order={{ base: 1, sm: 2 }}
          >
            <Box w={{ base: "100%", sm: "auto" }}>
              <Text fontSize={{ base: "xs", sm: "sm", md: "md" }} color="gray.800" fontWeight="bold" mb={1} mx={2}>
                From Date
              </Text>
              <Box
                as="input" type="date" value={fromDate} max={toDate}
                onChange={(e) => handleFromDateChange(e.target.value)}
                w={{ base: "100%", md: "180px" }}
                p={{ base: "5px 8px", sm: "7px 11px", md: "8px 12px" }}
                borderRadius="8px" border="1px solid" borderColor="gray.300"
                bg="white" fontSize={{ base: "13px", sm: "15px", md: "16px" }}
                cursor="pointer" transition="all 0.2s"
                _hover={{ borderColor: "gray.400" }}
                _focus={{ outline: "none", borderColor: "red.500", boxShadow: "0 0 0 3px rgba(244, 0, 9, 0.3)" }}
              />
            </Box>

            <Box w={{ base: "100%", sm: "auto" }}>
              <Text fontSize={{ base: "xs", sm: "sm", md: "md" }} fontWeight="bold" mb={1} mx={2} color="gray.800">
                To Date
              </Text>
              <Box
                as="input" type="date" value={toDate} min={fromDate}
                onChange={(e) => handleToDateChange(e.target.value)}
                w={{ base: "100%", md: "180px" }}
                p={{ base: "5px 8px", sm: "7px 11px", md: "8px 12px" }}
                borderRadius="8px" border="1px solid" borderColor="gray.300"
                bg="white" fontSize={{ base: "13px", sm: "15px", md: "16px" }}
                cursor="pointer" transition="all 0.2s"
                _hover={{ borderColor: "gray.400" }}
                _focus={{ outline: "none", borderColor: "red.500", boxShadow: "0 0 0 3px rgba(244, 0, 9, 0.3)" }}
              />
            </Box>
          </Flex>
        </Flex>

        <HStack spacing={{ base: 3, md: 5 }} align="flex-start" flexDir={{ base: "column", lg: "row" }}>
          <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, md: 6, lg: 0 }} borderRadius="18px" boxShadow="0 2px 4px rgba(199, 33, 39, 0.3)">
            <Select
              isMulti placeholder="RSM Name" options={Rsm} isLoading={rsmLoading}
              onChange={setSelectedRsm} isDisabled={rsmLoading}
              loadingMessage={() => "Loading RSM..."} noOptionsMessage={() => "No RSM found"}
              styles={customSelectStyles}
            />
          </Box>

          <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, md: 6, lg: 0 }} borderRadius="18px" boxShadow="0 4px 6px rgba(199, 33, 39, 0.3)">
            <Select
              isMulti placeholder="ASM Name" options={asm} value={selectedAsm}
              onChange={setSelectedAsm} styles={customSelectStyles}
              isLoading={asmLoading} isDisabled={asmLoading}
              loadingMessage={() => "Loading ASM..."} noOptionsMessage={() => "No ASM found"}
            />
          </Box>

          <Box w={{ base: "100%", sm: "auto" }} order={{ base: 2, sm: 1 }}>
            <Flex gap={3} align="center" direction={{ base: "column", sm: "row" }}>
              <Flex
                align="center" gap={1.5} bg="red.500"
                px={{ base: 3, md: 4 }} py={{ base: 1, md: 1.5 }}
                borderRadius="full" boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
              >
                <Text fontSize={{ base: "xs", sm: "sm", md: "md" }} fontWeight="bold" color="white">
                  {filteredCount < filterStores.length ? "Filtered:" : "Total:"}
                </Text>
                <Text color="white" fontSize={{ base: "sm", sm: "md", md: "lg" }} fontWeight="bold">
                  {filteredCount} Stores
                </Text>
              </Flex>

              <Button
                colorScheme="red" size={{ base: "sm", md: "md" }}
                onClick={handleDownloadImages} isLoading={downloadLoading}
                loadingText="Downloading..." spinner={<Spinner size="sm" color="white" />}
                rightIcon={!downloadLoading ? <Box as="span" fontSize={{ base: "14px", md: "18px" }}>⬇</Box> : null}
                w={{ base: "100%", sm: "auto" }} h={{ base: "32px", sm: "38px", md: "42px" }}
                px={{ base: 6, md: 9 }} fontSize={{ base: "xs", sm: "sm", md: "md" }}
                fontWeight="bold" boxShadow="0 2px 4px rgba(199, 33, 39, 0.3)"
                _hover={{ transform: downloadLoading ? "none" : "translateY(-2px)", boxShadow: downloadLoading ? "0 2px 4px rgba(199, 33, 39, 0.3)" : "0 4px 8px rgba(199, 33, 39, 0.4)" }}
                transition="all 0.2s" isDisabled={downloadLoading}
              >
                Download
              </Button>
            </Flex>
          </Box>
        </HStack>
      </Box>

      <Box mb={{ base: 3, lg: 0 }} >
        <AgGridWrapper
          rowData={filterStores}
          columnDefs={columnDefs}
          loading={loading}
          onGridReady={onGridReady}
          onFilterChanged={onFilterChanged}
          height="500px"
          extraGridProps={{
            pagination: true,
            paginationPageSize: pageSize,
            suppressPaginationPanel: true,
            headerHeight: window.innerWidth < 768 ? 55 : 65,
            onPaginationChanged: (params) => {
              setCurrentPage(params.api.paginationGetCurrentPage() + 1);
            },
          }}
        />
      </Box>

      <Flex
        justify="space-between" align="center" mt={4}
        px={{ base: 2, md: 4 }} flexDirection={{ base: "column", sm: "row" }}
        gap={{ base: 3, sm: 0 }}
      >
        <Text fontSize={{ base: "xs", sm: "sm" }} color="gray.600">
          Showing {filteredCount > 0 ? (currentPage - 1) * pageSize + 1 : 0} to{" "}
          {Math.min(currentPage * pageSize, filteredCount)} of {filteredCount} stores
        </Text>

        <Flex gap={2} align="center">
          <Button
            onClick={handlePrevious} isDisabled={currentPage === 1}
            size="sm" fontSize={{ base: "md", md: "lg" }} variant="outline" colorScheme="gray"
            leftIcon={<ChevronLeftIcon />} boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
            _hover={{ boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)" }}
            _disabled={{ opacity: 0.4, cursor: "not-allowed", boxShadow: "none" }}
          >
            Previous
          </Button>

          <Flex align="center" justify="center" bg="red.500" color="white"
            w={{ base: "32px", md: "40px" }} h={{ base: "32px", md: "40px" }}
            borderRadius="md" fontWeight="bold" fontSize={{ base: "sm", md: "md" }}
            boxShadow="0 2px 4px rgba(199, 33, 39, 0.3)"
          >
            {currentPage}
          </Flex>

          <Button
            onClick={handleNext} isDisabled={currentPage >= totalPages}
            size="sm" fontSize={{ base: "md", md: "lg" }} variant="outline" colorScheme="gray"
            rightIcon={<ChevronRightIcon />} boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
            _hover={{ boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)" }}
            _disabled={{ opacity: 0.4, cursor: "not-allowed", boxShadow: "none" }}
          >
            Next
          </Button>
        </Flex>
      </Flex>

      {/* Image Modal */}
      <ZoomImageModal
        isOpen={isOpen}
        onClose={onClose}
        imageUrl={imageUrl}
        isLoading={imageLoading}
        title={selectedStore?.storeName || "Store Image"}
        headerBg="red.500"
        headerColor="white"
        size="3xl"
      />
    </Box>
  );
}